import { AreaMaster } from '@/types/areaMaster'
import { JobMaster } from '@/types/jobMaster'
import { LiveStream } from '@/types/liveStream'

import type { Tab } from '../../node_modules/vue3-tabs-component/dist/types.d'

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
  NO_ANSWER: 0,
} as const

export type Gender = (typeof GENDER)[keyof typeof GENDER]

export interface UserProfileSearch {
  offset?: number
  limit?: number
  userName?: string
  profileText?: string
  jobMasterNo?: number
  subNo?: number
  areaMasterNo?: number
  jobName?: string
  jobSubName?: string
  offerAreaName?: string
  searchTarget?: number
  callNow?: boolean
}

export interface UserProfile {
  userNo: number
  indicateUserId: string
  userName: string
  pictureUrl: string
  jobMasterNo: number
  jobMaster?: JobMaster
  subNo: number
  areaMasterNo: number | null
  areaMaster?: AreaMaster
  movieUrl: string
  movieFileName: string
  profileText: string
  gender: Gender
  createdAt: string
  updatedAt: string
  listImgUrl: string
  liveStream: LiveStream[]
}

export interface UserProfilesResponse {
  meta: {
    perPage: number
    totalRows: number
  }
  data: {
    userProfileList: UserProfile[]
  }
}

export interface PickupUser {
  userNo: number
  sort: number
  createdAt: string
  updatedAt: string
  userProfile: UserProfile
}

export interface UserProfileDetailResponse {
  data: {
    userProfile: UserProfile
  }
}

export type UserProfileInOrder = Pick<UserProfile, 'indicateUserId' | 'userName' | 'pictureUrl' | 'gender'>

export interface GetNewlyByJobNoStoreParams {
  range: number
  offset: number
  limit: number
  jobMasNo: number
}

export interface GetPickupUsersByJobNoStoreParams {
  jobMasNo: number
}

export interface TabEventInterface {
  tab: Tab
}

export interface GetOnAirUsersParams {
  range: number
  offset: number
  limit: number
}
